var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSells(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9267_63874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4087 0L0.466797 14.9934V44.9274L26.5538 60L52.6407 44.9274V14.9934L26.4087 0Z",
    fill: "#C53437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5538 60L0.466797 44.9274V14.9934L26.5669 30.0528L26.5538 60Z",
    fill: "#9E071E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5669 30.0528L0.466797 14.9934L26.4087 0L52.6407 14.9934L26.5669 30.0528Z",
    fill: "#E34A4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0898 21.0911V37.048L37.1309 39.912V23.9551L42.0898 21.0911Z",
    fill: "#00ACCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0898 21.091L37.1309 23.9551L10.978 8.9221L15.9369 6.05804L42.0898 21.091Z",
    fill: "#4FC6E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9267_63874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1739,
    height: 60,
    fill: "white",
    transform: "translate(0.466797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSells);
export default __webpack_public_path__ + "static/media/sells.0eb3694d86a3fd1edbac178d5394d108.svg";
export { ForwardRef as ReactComponent };